/**
 * SECTION - INTERNATIONAL
 */
import RouteSelector from "../containers/RouteSelector";
import { views } from "./../services/constants";

const { international } = views;

const InternationalRoutes = {
  routes: [
    /*{
      path: ["/international", "/internacional"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalStudyInPortugal"
      }
    },
    {
      path: [
        "/international-study-in-portugal",
        "/internacional-estudar-portugal"
      ],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalStudyInPortugal"
      }
    },
    {
      path: ["/international-study-at-ua", "/internacional-estudar-na-ua"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalStudyAtUA"
      }
    },
    {
      path: ["/what-to-study", "/o-que-estudar"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "whatToStudy"
      }
    },
    {
      path: ["/international-applications", "/candidaturas-internacionais"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalApplication"
      }
    },
    {
      path: ["/international-know-us", "/internacional-conhecer-ua"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalKnowUs"
      }
    },
    {
      path: ["/ua-world", "/ua-mundo"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "uaWorld"
      }
    },
    {
      path: ["/international-info", "/internacional-info"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalInfo"
      }
    },
    {
      path: ["/international-fees", "/internacional-taxas"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalFees"
      }
    },
    {
      path: ["/international-scholarships", "/internacional-bolsas"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalScholarships"
      }
    },
    {
      path: ["/international-support", "/servicos-apoio"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalSupport"
      }
    },
    {
      path: ["/international-before", "/internacional-preparar-vinda"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalBefore"
      }
    },
    {
      path: ["/mobility", "/mobilidade"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "mobility"
      }
    },
    {
      path: ["/international-cooperation", "/internacional-cooperacao"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "internationalCooperation"
      }
    },
    {
      path: ["/mobility-outgoing", "/mobilidade-outgoing"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "mobilityOutgoing"
      }
    },
    {
      path: ["/mobility-incoming", "/mobilidade-incoming"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "mobilityIncoming"
      }
    },
    {
      path: ["/living-aveiro", "/viver-aveiro"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "livingAveiro"
      }
    },
    {
      path: ["/why-portugal", "/porque-portugal"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "whyPortugal"
      }
    },
    {
      path: ["/study-cycles", "/ciclo-estudos"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "studyCycles"
      }
    },
    {
      path: ["/research-facilities", "/onde-investigar"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "researchFacilities"
      }
    },
    {
      path: ["/campuses-life", "/vida-campi"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "campusesLife"
      }
    },
    {
      path: ["/exchange-packages", "/pacotes-intercambio"],
      component: RouteSelector,
      props: {
        activeView: international,
        document: "exchangePackages"
      }
    }*/
  ]
};

export default InternationalRoutes;
